export default "__VITE_ASSET__FCC2aF$C__"